import t from 'ember-intl/helpers/t';
import Index from 'frontend/components/index';
<template>
  <div id="index-head">{{t "general.indexHead"}}</div>

  <Index />
</template>
